type _LogLevel = 'debug' | 'info' | 'warn' | 'error'

const isProduction = process.env.NODE_ENV === 'production'

export const logger = {
    debug: (...args: unknown[]): void => {
        if (!isProduction) {
            console.debug(...args)
        }
    },
    info: (...args: unknown[]): void => {
        if (!isProduction) {
            console.info(...args)
        }
    },
    warn: (...args: unknown[]): void => {
        console.warn(...args)
    },
    error: (...args: unknown[]): void => {
        console.error(...args)
    }
}
